import { Injectable, Injector } from "@angular/core";
import {
  HttpClient,
  HttpHeaders,
} from "@angular/common/http";
import { Observable, of } from "rxjs";
import { catchError, tap } from "rxjs/operators";
import { AppSettings } from "../AppSettings";
import "rxjs/add/observable/fromEvent";
import { UtilService } from "./util.service";
import { MessageServices } from "./message.services";
import { Router } from "@angular/router";
let id;

if (
  localStorage.getItem("user_id") == null ||
  localStorage.getItem("user_id") == ""
) {
  id = "";
  // console.log("ID ====" + id);
} else {
  id = localStorage.getItem("user_id");
  // console.log("ID ====" + id);
}

let httpOptions = {
  headers: new HttpHeaders({
    "Content-Type": AppSettings.HTTP_CONTENT_TYPE,
    "Access-Control-Allow-Origin": AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
    "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
    Channel: "WEB",
    userId: id,
  }),
};


function setID() {
  if (
    localStorage.getItem("user_id") == null ||
    localStorage.getItem("user_id") == ""
  ) {
    id = "";
    // console.log("ID ====" + id);
  } else {
    id = localStorage.getItem("user_id");
    // console.log("ID ====" + id);
  }
}

@Injectable({
  providedIn: "root",
})
export class ApiService {
  token = null;
  private MessageServices: MessageServices;

  constructor(
    private http: HttpClient,
    private injector: Injector,
    // private MessageServices:MessageServices
    private util: UtilService,
    private router: Router,
  ) {
    if (localStorage.getItem('token')) {
      this.token = localStorage.getItem("token");
    }
  }

  setUserId() {
    httpOptions.headers = new HttpHeaders();
    httpOptions.headers = httpOptions.headers.set(
      "Content-Type",
      AppSettings.HTTP_CONTENT_TYPE
    );
    httpOptions.headers = httpOptions.headers.set(
      "Access-Control-Allow-Origin",
      AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN
    );
    httpOptions.headers = httpOptions.headers.set(
      "userId",
      localStorage.getItem("user_id")
    );
    httpOptions.headers = httpOptions.headers.set("Channel", "WEB");
    this.token = null;
    setTimeout(() => {
      this.token = localStorage.getItem("token");
    }, 0);
  }

  sessionCheck(message) {
    // let messageAPI = this.injector.get(MessageServices);
    // let headerAPI = this.injector.get(HeaderComponent);
    let session = message.sessionData;
    if (session != undefined && !Array.isArray(session)) {
      if (Number(session.code) === 8888 || Number(session.code) === 9999) {
        console.log("Condition met:", session.code);
        // let util = this.injector.get(UtilService);
        // util.stopLoader();
        // this.MessageServices.errorText("User Session Invalid, Login again");
        this.logout().subscribe({
          next: (response) => {
            let brand = localStorage.getItem("brand");
            if (response.code == "0000") {
              if (brand == "Nissan") {
                this.util.stopLoader();
                this.util.clearAllLocalStorage();
                this.router.navigate(["/nissan-login"]);
                this.MessageServices.success("MP35");
              } else if (brand == "Renault") {
                this.util.stopLoader();
                this.util.clearAllLocalStorage();
                this.router.navigate(["/renault-login"]);
                this.MessageServices.success("MP35");
              } else {
                this.util.stopLoader();
                this.util.clearAllLocalStorage();
                this.router.navigate(["/login"]);
                this.MessageServices.success("MP35");
              }
            } else if (response.code == "9999") {
              this.util.stopLoader();
              this.MessageServices.error("MP92");
            } else {
              this.util.stopLoader();
              this.util.clearAllLocalStorage();
            }
          },
          error: (err) => {
            console.error("Logout failed", err);
          }
        });

      }
    } else {
      // console.log("Session is undefined or an array.");
      // this.bnIdle.resetTimer();
    }
  }

  query(path): Observable<any> {
    let token = localStorage.getItem("token");
    let url = AppSettings.SERVER_URL + path;
    let httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": AppSettings.HTTP_CONTENT_TYPE,
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${token}`,
        token: token,
      }),
    };
    return this.http.get<any>(url, httpOptions).pipe(
      tap((data: any) => {
        try {
          // console.log("Response data:", data);
          this.sessionCheck(data);
        } catch (err) {
          console.warn(err);
        }
      }),
      catchError(this.handleError<any>("Query"))
    );
  }

  query_common(path): Observable<any> {
    let httpOptions_common = {
      headers: new HttpHeaders({
        "Content-Type": AppSettings.HTTP_CONTENT_TYPE,
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
      }),
    };
    let url = AppSettings.SERVER_URL + path;
    return this.http.get<any>(url, httpOptions_common).pipe(
      tap((data: any) => {
        try {
          this.sessionCheck(data);
        } catch (err) {
          console.warn(err);
        }
      }),
      catchError(this.handleError<any>("Query"))
    );
  }

  // COMMON///////////////////////////////////////////////////////////////////////////////////

  userLogin(loginData): Observable<any> {
    let url = AppSettings.SERVER_URL + AppSettings.USER_LOGIN;
    var credentials = btoa(loginData.email + ":" + loginData.password);
    const httpOptionslogin = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        channel: "WEB",
        Authorization: "Basic " + credentials,
      }),
    };

    return this.http.get<any>(url, httpOptionslogin).pipe(
      tap((data: any) => {
        if (data && data.data && data.data.token) {
          localStorage.setItem("token", data.data.token);
          this.token = localStorage.getItem("token");
          setID();
        } else {
          console.warn(
            "Token not found in the response or data structure is unexpected"
          );
        }
      }),
      catchError(this.handleError<any>("getauthentication"))
    );
  }

  changePassword(userData): Observable<any> {
    let url = AppSettings.SERVER_URL + AppSettings.CHANGE_PASSWORD;

    const httpOptionschange = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        channel: "WEB",
        //userId: localStorage.getItem("email"),
      }),
    };

    return this.http.post<any>(url, userData, httpOptionschange).pipe(
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("changepassword"))
    );
  }

  preChangePassword(userData, emailid): Observable<any> {
    let token = localStorage.getItem("token");
    let httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": AppSettings.HTTP_CONTENT_TYPE,
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${token}`,
        token: token,
      }),
    };
    let url =
      AppSettings.SERVER_URL + AppSettings.PRE_CHANGE_PASSWORD + emailid;
    return this.http.post<any>(url, userData, httpOptions).pipe(
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("changepassword"))
    );
  }

  forgetpassword(userData): Observable<any> {
    let url = AppSettings.SERVER_URL + AppSettings.FORGET_PASSWORD;

    const httpOptionschange = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        channel: "WEB",
      }),
    };

    return this.http.post<any>(url, userData, httpOptionschange).pipe(
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("ForgetPassword"))
    );
  }

  getAllStatus(): Observable<any> {
    let token = localStorage.getItem("token");
    let httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": AppSettings.HTTP_CONTENT_TYPE,
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${token}`,
        token: token,
      }),
    };
    let url = AppSettings.SERVER_URL + AppSettings.GET_STATUS;
    return this.http.get<any>(url, httpOptions).pipe(
      tap((data: any) => {
        try {
          this.sessionCheck(data);
        } catch (err) {
          console.warn(err);
        }
      }),
      catchError(this.handleError<any>("getAllStatus"))
    );
  }

  checkSession(): Observable<any> {
    let token = localStorage.getItem("token");
    let httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": AppSettings.HTTP_CONTENT_TYPE,
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${token}`,
        token: token,
      }),
    };
    let url = AppSettings.SERVER_URL + AppSettings.USER_SESSION;
    return this.http.get<any>(url, httpOptions).pipe(
      tap((data: any) => {
        try {
          this.sessionCheck(data);
        } catch (err) {
          console.warn(err);
        }
      }),
      catchError(this.handleError<any>("checkSession"))
    );
  }

  getAllRegions(): Observable<any> {
    let token = localStorage.getItem("token");
    let httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": AppSettings.HTTP_CONTENT_TYPE,
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${token}`,
        token: token,
      }),
    };
    let url = AppSettings.SERVER_URL + "regions";
    return this.http.get<any>(url, httpOptions).pipe(
      tap((data: any) => {
        try {
          this.sessionCheck(data);
        } catch (err) {
          console.warn(err);
        }
      }),
      catchError(this.handleError<any>("getAllRegions"))
    );
  }
  getAllSubRegion(): Observable<any> {
    let token = localStorage.getItem("token");
    let httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": AppSettings.HTTP_CONTENT_TYPE,
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${token}`,
        token: token,
      }),
    };
    let url = AppSettings.SERVER_URL + "destination/subregions";
    return this.http.get<any>(url, httpOptions).pipe(
      tap((data: any) => {
        try {
          this.sessionCheck(data);
        } catch (err) {
          console.warn(err);
        }
      }),
      catchError(this.handleError<any>("getAllSubRegions"))
    );
  }

  getstate(state): Observable<any> {
    let token = localStorage.getItem("token");
    let httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": AppSettings.HTTP_CONTENT_TYPE,
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${token}`,
        token: token,
      }),
    };
    let url = AppSettings.SERVER_URL + "region/state/" + state;
    return this.http.get<any>(url, httpOptions).pipe(
      tap((data: any) => {
        try {
          this.sessionCheck(data);
        } catch (err) {
          console.warn(err);
        }
      }),
      catchError(this.handleError<any>("getstate"))
    );
  }

  getAllStates(): Observable<any> {
    let token = localStorage.getItem("token");
    let httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": AppSettings.HTTP_CONTENT_TYPE,
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${token}`,
        token: token,
      }),
    };
    let url = AppSettings.SERVER_URL + "states";
    return this.http.get<any>(url, httpOptions).pipe(
      tap((data: any) => {
        try {
          this.sessionCheck(data);
        } catch (err) {
          console.warn(err);
        }
      }),
      catchError(this.handleError<any>("getAllStates"))
    );
  }

  getAllEnroute(): Observable<any> {
    let token = localStorage.getItem("token");
    let httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": AppSettings.HTTP_CONTENT_TYPE,
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${token}`,
        token: token,
      }),
    };
    let url = AppSettings.SERVER_URL + "routecombinations";
    return this.http.get<any>(url, httpOptions).pipe(
      tap((data: any) => {
        try {
          this.sessionCheck(data);
        } catch (err) {
          console.warn(err);
        }
      }),
      catchError(this.handleError<any>("getAllEnroute"))
    );
  }

  getDestination(): Observable<any> {
    let token = localStorage.getItem("token");
    let httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": AppSettings.HTTP_CONTENT_TYPE,
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${token}`,
        token: token,
      }),
    };
    let url = AppSettings.SERVER_URL + "destinations";
    return this.http.get<any>(url, httpOptions).pipe(
      tap((data: any) => {
        try {
          this.sessionCheck(data);
        } catch (err) {
          console.warn(err);
        }
      }),
      catchError(this.handleError<any>("getDestination"))
    );
  }

  getdestinationlist(): Observable<any> {
    let token = localStorage.getItem("token");
    let httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": AppSettings.HTTP_CONTENT_TYPE,
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${token}`,
        token: token,
      }),
    };
    //let url = AppSettings.SERVER_URL + "destination/list";
    let url = AppSettings.SERVER_URL + "destinations";
    return this.http.get<any>(url, httpOptions).pipe(
      tap((data: any) => {
        try {
          this.sessionCheck(data);
        } catch (err) {
          console.warn(err);
        }
      }),
      catchError(this.handleError<any>("getDestination"))
    );
  }

  getRegion(): Observable<any> {
    let token = localStorage.getItem("token");
    let httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": AppSettings.HTTP_CONTENT_TYPE,
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${token}`,
        token: token,
      }),
    };
    let url = AppSettings.SERVER_URL + "regions";
    return this.http.get<any>(url, httpOptions).pipe(
      tap((data: any) => {
        try {
          this.sessionCheck(data);
        } catch (err) {
          console.warn(err);
        }
      }),
      catchError(this.handleError<any>("getRegion"))
    );
  }

  getAllLabel(): Observable<any> {
    let httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": AppSettings.HTTP_CONTENT_TYPE,
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
      }),
    };
    let url = AppSettings.SERVER_URL + AppSettings.GET_LABEL;
    return this.http.get<any>(url, httpOptions).pipe(
      tap((data: any) => {
        try {
          this.sessionCheck(data);
        } catch (err) {
          console.warn(err);
        }
      }),
      catchError(this.handleError<any>("getAllLabel"))
    );
  }

  getAllroles(): Observable<any> {
    let token = localStorage.getItem("token");
    let httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": AppSettings.HTTP_CONTENT_TYPE,
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${token}`,
        token: token,
      }),
    };
    let url = AppSettings.SERVER_URL + AppSettings.GET_ROLES;
    return this.http.get<any>(url, httpOptions).pipe(
      tap((data: any) => {
        try {
          this.sessionCheck(data);
        } catch (err) {
          console.warn(err);
        }
      }),
      catchError(this.handleError<any>("getUserQuery"))
    );
  }

  getAllconfig(): Observable<any> {
    let token = localStorage.getItem("token");
    let httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": AppSettings.HTTP_CONTENT_TYPE,
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${token}`,
        token: token,
      }),
    };
    let url = AppSettings.SERVER_URL + "makercheckerConfigs";
    return this.http.get<any>(url, httpOptions).pipe(
      tap((data: any) => {
        try {
          this.sessionCheck(data);
        } catch (err) {
          console.warn(err);
        }
      }),
      catchError(this.handleError<any>("getAllconfig"))
    );
  }

  getAllScreens(): Observable<any> {
    let token = localStorage.getItem("token");
    let httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": AppSettings.HTTP_CONTENT_TYPE,
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${token}`,
        token: token,
      }),
    };
    let url = AppSettings.SERVER_URL + "makercheckerScreens";
    return this.http.get<any>(url, httpOptions).pipe(
      tap((data: any) => {
        try {
          this.sessionCheck(data);
        } catch (err) {
          console.warn(err);
        }
      }),
      catchError(this.handleError<any>("getAllScreens"))
    );
  }

  changeTOStatus(toId, status): Observable<any> {
    let token = localStorage.getItem("token");
    let httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": AppSettings.HTTP_CONTENT_TYPE,
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${token}`,
        token: token,
      }),
    };
    let url =
      AppSettings.SERVER_URL +
      AppSettings.CHANGE_TO_STATUS +
      toId +
      "/" +
      status;
    return this.http.put<any>(url, httpOptions).pipe(
      tap((data: any) => {
        try {
          this.sessionCheck(data);
        } catch (err) {
          console.warn(err);
        }
      }),
      catchError(this.handleError<any>("TOstatus"))
    );
  }
  excelDownload(searchData: any, arg1: string) {
    let token = localStorage.getItem("token");
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${token}`,
        token: token,
      }),
    };
    let url = AppSettings.SERVER_URL + arg1;
    return this.http.post<any>(url, searchData, httpOptions).pipe(
      tap((data: any) => {
        try {
          this.sessionCheck(data);
        } catch (err) {
          console.warn(err);
        }
      }),
      catchError(this.handleError<any>("excelDownload"))
    );
  }

  getAllServices(): Observable<any> {
    let token = localStorage.getItem("token");
    let httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": AppSettings.HTTP_CONTENT_TYPE,
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${token}`,
        token: token,
      }),
    };
    let url = AppSettings.SERVER_URL + AppSettings.GET_ALL_SERVICES;
    return this.http.get<any>(url, httpOptions).pipe(
      tap((data: any) => {
        try {
          this.sessionCheck(data);
        } catch (err) {
          console.warn(err);
        }
      }),
      catchError(this.handleError<any>("getUserQuery"))
    );
  }

  getYardMaster(): Observable<any> {
    let token = localStorage.getItem("token");
    let httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": AppSettings.HTTP_CONTENT_TYPE,
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${token}`,
        token: token,
      }),
    };
    let url = AppSettings.SERVER_URL + "findall/yard";
    return this.http.get<any>(url, httpOptions).pipe(
      tap((data: any) => {
        try {
          this.sessionCheck(data);
        } catch (err) {
          console.warn(err);
        }
      }),
      catchError(this.handleError<any>("getYardMaster"))
    );
  }

  getRowMaster(r): Observable<any> {
    let token = localStorage.getItem("token");
    let httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": AppSettings.HTTP_CONTENT_TYPE,
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${token}`,
        token: token,
      }),
    };
    let url = AppSettings.SERVER_URL + AppSettings.GET_ROW_MASTER + r;
    return this.http.get<any>(url, httpOptions).pipe(
      tap((data: any) => {
        try {
          this.sessionCheck(data);
        } catch (err) {
          console.warn(err);
        }
      }),
      catchError(this.handleError<any>("getYardMaster"))
    );
  }

  create(u, userData): Observable<any> {
    let token = localStorage.getItem("token");
    let httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": AppSettings.HTTP_CONTENT_TYPE,
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${token}`,
        token: token,
      }),
    };
    let url = AppSettings.SERVER_URL + u;
    return this.http.post<any>(url, userData, httpOptions).pipe(
      tap((data: any) => {
        try {
          this.sessionCheck(data);
        } catch (err) {
          console.warn(err);
        }
      }),
      catchError(this.handleError<any>("Create"))
    );
  }

  Post(u, userData) {
    let token = localStorage.getItem("token");
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${token}`,
        token: token,
      }),
    };

    let url = AppSettings.SERVER_URL + u;
    return this.http.post<any>(url, userData, httpOptions).pipe(
      tap((data: any) => {
        try {
          this.sessionCheck(data);
        } catch (err) {
          console.warn(err);
        }
      }),
      catchError(this.handleError<any>("Create"))
    );
  }

  create_common(u, userData): Observable<any> {
    let httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": AppSettings.HTTP_CONTENT_TYPE,
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
      }),
    };
    let url = AppSettings.SERVER_URL + u;
    return this.http.post<any>(url, userData, httpOptions).pipe(
      tap((data: any) => {
        try {
          this.sessionCheck(data);
        } catch (err) {
          console.warn(err);
        }
      }),
      catchError(this.handleError<any>("Create"))
    );
  }

  checkSuperUser(u, userData): Observable<any> {
    let token = localStorage.getItem("token");
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${token}`,
        token: token,
      }),
    };
    let url = AppSettings.SERVER_URL + u;
    return this.http.post<any>(url, userData, httpOptions).pipe(
      tap((data: any) => {
        try {
          this.sessionCheck(data);
        } catch (err) {
          console.warn(err);
        }
      }),
      catchError(this.handleError<any>("SuperUser"))
    );
  }

  createEnroute(data): Observable<any> {
    let token = localStorage.getItem("token");
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${token}`,
        token: token,
      }),
    };
    let url = AppSettings.SERVER_URL + "routecombination/create";
    return this.http.post<any>(url, data, httpOptions).pipe(
      tap((data: any) => {
        try {
          this.sessionCheck(data);
        } catch (err) {
          console.warn(err);
        }
      }),
      catchError(this.handleError<any>("createEnroute"))
    );
  }

  updateEnroute(data): Observable<any> {
    let token = localStorage.getItem("token");
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${token}`,
        token: token,
      }),
    };
    let url = AppSettings.SERVER_URL + "routecombination/update";
    return this.http.put<any>(url, data, httpOptions).pipe(
      tap((data: any) => {
        try {
          this.sessionCheck(data);
        } catch (err) {
          console.warn(err);
        }
      }),
      catchError(this.handleError<any>("updateEnroute"))
    );
  }

  deleteEnroute(data): Observable<any> {
    let token = localStorage.getItem("token");
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${token}`,
        token: token,
      }),
    };
    let url = AppSettings.SERVER_URL + "routecombination/delete";
    return this.http.post<any>(url, data, httpOptions).pipe(
      tap((data: any) => {
        try {
          this.sessionCheck(data);
        } catch (err) {
          console.warn(err);
        }
      }),
      catchError(this.handleError<any>("deleteEnroute"))
    );
  }

  createDestination(data): Observable<any> {
    let token = localStorage.getItem("token");
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${token}`,
        token: token,
      }),
    };
    let url = AppSettings.SERVER_URL + "destination/create";
    return this.http.post<any>(url, data, httpOptions).pipe(
      tap((data: any) => {
        try {
          this.sessionCheck(data);
        } catch (err) {
          console.warn(err);
        }
      }),
      catchError(this.handleError<any>("createDestination"))
    );
  }

  updateDestination(data): Observable<any> {
    let token = localStorage.getItem("token");
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${token}`,
        token: token,
      }),
    };
    let url = AppSettings.SERVER_URL + "destination/update";
    return this.http.post<any>(url, data, httpOptions).pipe(
      tap((data: any) => {
        try {
          this.sessionCheck(data);
        } catch (err) {
          console.warn(err);
        }
      }),
      catchError(this.handleError<any>("updateDestination"))
    );
  }

  deleteDestination(data): Observable<any> {
    let token = localStorage.getItem("token");
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${token}`,
        token: token,
      }),
    };
    let url = AppSettings.SERVER_URL + "destination/delete";
    return this.http.post<any>(url, data, httpOptions).pipe(
      tap((data: any) => {
        try {
          this.sessionCheck(data);
        } catch (err) {
          console.warn(err);
        }
      }),
      catchError(this.handleError<any>("deleteDestination"))
    );
  }

  ttaresult(data): Observable<any> {
    let token = localStorage.getItem("token");
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${token}`,
        token: token,
      }),
    };
    let url = AppSettings.SERVER_URL + "batch/allocation";
    return this.http.post<any>(url, data, httpOptions).pipe(
      tap((data: any) => {
        try {
          this.sessionCheck(data);
        } catch (err) {
          console.warn(err);
        }
      }),
      catchError(this.handleError<any>("ttsQuery"))
    );
  }

  update(u, userData): Observable<any> {
    let token = localStorage.getItem("token");
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${token}`,
        token: token,
      }),
    };
    let url = AppSettings.SERVER_URL + u;
    return this.http.put<any>(url, userData, httpOptions).pipe(
      tap((data: any) => {
        try {
          this.sessionCheck(data);
        } catch (err) {
          console.warn(err);
        }
      }),
      catchError(this.handleError<any>("Update"))
    );
  }

  filterQuery(u, userData): Observable<any> {
    let token = localStorage.getItem("token");
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${token}`,
        token: token,
      }),
    };
    let url = AppSettings.SERVER_URL + u;
    return this.http.post<any>(url, userData, httpOptions).pipe(
      tap((data: any) => {
        try {
          this.sessionCheck(data);
        } catch (err) {
          console.warn(err);
        }
      }),
      catchError(this.handleError<any>("Create"))
    );
  }
  sobReportFilter(u, userData): Observable<any> {
    let token = localStorage.getItem("token");
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${token}`,
        token: token,
      }),
    };
    let url = AppSettings.SERVER_URL + u;
    return this.http.post<any>(url, userData, httpOptions).pipe(
      tap((data: any) => {
        try {
          this.sessionCheck(data);
        } catch (err) {
          console.warn(err);
        }
      }),
      catchError(this.handleError<any>("Create"))
    );
  }

  entryReport(u, userData): Observable<any> {
    let token = localStorage.getItem("token");
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${token}`,
        token: token,
      }),
    };
    let url = AppSettings.SERVER_URL + u;
    return this.http.post<any>(url, userData, httpOptions).pipe(
      tap((data: any) => {
        try {
          this.sessionCheck(data);
        } catch (err) {
          console.warn(err);
        }
      }),
      catchError(this.handleError<any>("Create"))
    );
  }
  dailySummary(u, userData): Observable<any> {
    let token = localStorage.getItem("token");
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${token}`,
        token: token,
      }),
    };
    let url = AppSettings.SERVER_URL + u;
    return this.http.post<any>(url, userData, httpOptions).pipe(
      tap((data: any) => {
        try {
          this.sessionCheck(data);
        } catch (err) {
          console.warn(err);
        }
      }),
      catchError(this.handleError<any>("Create"))
    );
  }
  ttsUndo(u, userData): Observable<any> {
    let token = localStorage.getItem("token");
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${token}`,
        token: token,
      }),
    };
    let url = AppSettings.SERVER_URL + u;
    return this.http.post<any>(url, userData, httpOptions).pipe(
      tap((data: any) => {
        try {
          this.sessionCheck(data);
        } catch (err) {
          console.warn(err);
        }
      }),
      catchError(this.handleError<any>("Create"))
    );
  }

  delete(u, userData): Observable<any> {
    let token = localStorage.getItem("token");
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${token}`,
        token: token,
      }),
    };
    let url = AppSettings.SERVER_URL + u;
    return this.http.post<any>(url, userData, httpOptions).pipe(
      tap((data: any) => {
        try {
          this.sessionCheck(data);
        } catch (err) {
          console.warn(err);
        }
      }),
      catchError(this.handleError<any>("Create"))
    );
  }

  ttaReport(data): Observable<any> {
    let token = localStorage.getItem("token");
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${token}`,
        token: token,
      }),
    };
    let url = AppSettings.SERVER_URL + "tta/report1";
    return this.http.post<any>(url, data, httpOptions).pipe(
      tap((data: any) => {
        try {
          this.sessionCheck(data);
        } catch (err) {
          console.warn(err);
        }
      }),
      catchError(this.handleError<any>("Report"))
    );
  }

  sobReport(data): Observable<any> {
    let token = localStorage.getItem("token");
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${token}`,
        token: token,
      }),
    };
    let url = AppSettings.SERVER_URL + "fetchsob/monthwise";
    return this.http.post<any>(url, data, httpOptions).pipe(
      tap((data: any) => {
        try {
          this.sessionCheck(data);
        } catch (err) {
          console.warn(err);
        }
      }),
      catchError(this.handleError<any>("sobReport"))
    );
  }

  epodReport(data): Observable<any> {
    let token = localStorage.getItem("token");
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${token}`,
        token: token,
      }),
    };
    let url = AppSettings.SERVER_URL + "dealer/epod/report";
    return this.http.post<any>(url, data, httpOptions).pipe(
      tap((data: any) => {
        try {
          this.sessionCheck(data);
        } catch (err) {
          console.warn(err);
        }
      }),
      catchError(this.handleError<any>("Report"))
    );
  }

  ttaChangeReport(data): Observable<any> {
    let token = localStorage.getItem("token");
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${token}`,
        token: token,
      }),
    };
    let url = AppSettings.SERVER_URL + "tta/analysis/report";
    return this.http.post<any>(url, data, httpOptions).pipe(
      tap((data: any) => {
        try {
          this.sessionCheck(data);
        } catch (err) {
          console.warn(err);
        }
      }),
      catchError(this.handleError<any>("Report"))
    );
  }
  // getAllUsersOne(): Observable<any> {
  //   let httpOptions = {
  //     headers: new HttpHeaders({
  //       "Access-Control-Allow-Origin": AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
  //       "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
  //       Channel: "WEB",
  //       userId: localStorage.getItem("user_id")
  //     }),
  //   };
  //   let url = AppSettings.SERVER_URL + AppSettings.GET_ALL_USER;
  //   return this.http.get<any>(url, httpOptions).pipe(
  //     tap((data: any) => this.sessionCheck(data)),
  //     catchError(this.handleError<any>("getUserQuery"))
  //   );
  // }
  //chnaged
  getAllUsers(obj: any): Observable<any> {
    let token = localStorage.getItem("token");
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${token}`,
        token: token,
      }),
    };
    let url = AppSettings.SERVER_URL + AppSettings.GET_ALL_USER;
    return this.http.post<any>(url, obj, httpOptions).pipe(
      tap((data: any) => {
        try {
          this.sessionCheck(data);
        } catch (err) {
          console.warn(err);
        }
      }),
      catchError(this.handleError<any>("getUserQuery"))
    );
  }

  // USER MANAGEMENT

  transCodeQuery(): Observable<any> {
    let token = localStorage.getItem("token");
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${token}`,
        token: token,
      }),
    };
    let url = AppSettings.SERVER_URL + AppSettings.GET_ALL_TCODE;
    return this.http.get<any>(url, httpOptions).pipe(
      tap((data: any) => {
        try {
          this.sessionCheck(data);
        } catch (err) {
          console.warn(err);
        }
      }),
      catchError(this.handleError<any>("getUserQuery"))
    );
  }

  createUser(userData): Observable<any> {
    let token = localStorage.getItem("token");
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${token}`,
        token: token,
      }),
    };
    // let url = AppSettings.SERVER_URL + AppSettings.CREATE_USER;
    let url = AppSettings.SERVER_URL + "user";
    return this.http.post<any>(url, userData, httpOptions).pipe(
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("VLMUpload"))
    );
  }

  createBulkUser(userData): Observable<any> {
    let token = localStorage.getItem("token");
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${token}`,
        token: token,
      }),
    };
    let url = AppSettings.SERVER_URL + "user/bulk/create";
    return this.http.post<any>(url, userData, httpOptions).pipe(
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("VLMUpload"))
    );
  }

  createBulkDestination(DestinationList): Observable<any> {
    let token = localStorage.getItem("token");
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${token}`,
        token: token,
      }),
    };
    let url = AppSettings.SERVER_URL + "destination/bulk/update";
    return this.http.post<any>(url, DestinationList, httpOptions).pipe(
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("VLMUpload"))
    );
  }

  updateUser(userData): Observable<any> {
    let token = localStorage.getItem("token");
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${token}`,
        token: token,
      }),
    };
    let url = AppSettings.SERVER_URL + AppSettings.CREATE_USER;
    return this.http.put<any>(url, userData, httpOptions).pipe(
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("VLMUpload"))
    );
  }

  getUserDetails(userId): Observable<any> {
    let token = localStorage.getItem("token");
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${token}`,
        token: token,
      }),
    };
    let url = AppSettings.SERVER_URL + AppSettings.GET_USER_DETAILS + userId;
    return this.http.get<any>(url, httpOptions).pipe(
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("getUserQuery"))
    );
  }

  deleteUser(u) {
    let token = localStorage.getItem("token");
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${token}`,
        token: token,
      }),
    };
    let url = AppSettings.SERVER_URL + "user/status/" + u;
    return this.http.delete<any>(url, httpOptions).pipe(
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("deleteUser"))
    );
  }

  stockUpdate(data): Observable<any> {
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${this.token}`,
        token: this.token,
      }),
    };
    let url = AppSettings.SERVER_URL + "cardetail/bulk/create";
    console.log("In");
    return this.http.post<any>(url, data, httpOptions).pipe(
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("VLMUpload"))
    );
  }

  picklistUpdate(data): Observable<any> {
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${this.token}`,
        token: this.token,
      }),
    };
    let url = AppSettings.SERVER_URL + "create/picklists";
    return this.http.post<any>(url, data, httpOptions).pipe(
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("PickList"))
    );
  }

  // DEALER

  dealerTracking(datas) {
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${this.token}`,
        token: this.token,
      }),
    };
    let url = AppSettings.SERVER_URL + "user/dealerwise/report";
    return this.http.post<any>(url, datas, httpOptions).pipe(
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("dealerTracking"))
    );
  }

  getAllDealer(): Observable<any> {
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${this.token}`,
        token: this.token,
      }),
    };
    let url = AppSettings.SERVER_URL + AppSettings.GET_DEALERS;
    return this.http.get<any>(url, httpOptions).pipe(
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("getAllDealer"))
    );
  }

  getDealerQuery(dealercode: any): Observable<any> {
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${this.token}`,
        token: this.token,
      }),
    };
    let url = AppSettings.SERVER_URL + AppSettings.DEALER_DETAILS + dealercode;
    return this.http.post<any>(url, httpOptions).pipe(
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("getDealerQuery"))
    );
  }

  dealerSearch(dealercode, searchData): Observable<any> {
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${this.token}`,
        token: this.token,
      }),
    };
    let url = AppSettings.SERVER_URL + AppSettings.DEALER_DETAILS + dealercode;
    return this.http.post<any>(url, searchData, httpOptions).pipe(
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("Search dealer"))
    );
  }

  Salesearch(dealercode, searchData): Observable<any> {
    //sales/summary/search
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${this.token}`,
        token: this.token,
      }),
    };
    let url = AppSettings.SERVER_URL + AppSettings.SaleSearch;
    return this.http.post<any>(url, searchData, httpOptions).pipe(
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("Search dealer"))
    );
  }


  ExportSearch(searchData): Observable<any> {
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${this.token}`,
        token: this.token,
      }),
    };
    let url = AppSettings.SERVER_URL + AppSettings.EXPORT;
    return this.http.post<any>(url, searchData, httpOptions).pipe(
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("Search dealer"))
    );
  }


  getTruckDetails(tono, dealercode, type?: any): Observable<any> {
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${this.token}`,
        token: this.token,
      }),
    };

    if (type == "insurance") {
      // let url =
      // AppSettings.SERVER_URL +
      // AppSettings.GET_TRUCK_DETAILS +
      // dealercode +
      // "/" +
      // tono;
      let url = `${AppSettings.SERVER_URL}dealer/epod/ng/vin/${dealercode}/${tono}`;
      return this.http.get<any>(url, httpOptions).pipe(
        tap((data: any) => this.sessionCheck(data)),
        catchError(this.handleError<any>("getTruckDetail"))
      );
    } else {
      let url =
        AppSettings.SERVER_URL +
        AppSettings.GET_TRUCK_DETAILS +
        dealercode +
        "/" +
        tono;
      return this.http.get<any>(url, httpOptions).pipe(
        tap((data: any) => this.sessionCheck(data)),
        catchError(this.handleError<any>("getTruckDetail"))
      );
    }
  }

  // TRANSPORTER

  getAllTransporter(): Observable<any> {
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
      }),
    };
    let url = AppSettings.SERVER_URL + AppSettings.GET_TRANSPORTER;
    return this.http.get<any>(url, httpOptions).pipe(
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("getAllTransporter"))
    );
  }

  getTransporterQuery(transcode, s): Observable<any> {
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${this.token}`,
        token: this.token,
      }),
    };
    let url =
      AppSettings.SERVER_URL + AppSettings.TRANSPORTER_DETAILS + transcode;
    return this.http.post<any>(url, s, httpOptions).pipe(
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("getTransQuery"))
    );
  }

  transporterSearch(transcode, searchData): Observable<any> {
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${this.token}`,
        token: this.token,
      }),
    };
    let url =
      AppSettings.SERVER_URL + AppSettings.TRANSPORTER_DETAILS + transcode;

    return this.http.post<any>(url, searchData, httpOptions).pipe(
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("Search transporter"))
    );
  }

  getTransTruckDetails(tono, transcode, truckno): Observable<any> {
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${this.token}`,
        token: this.token,
      }),
    };
    let url =
      AppSettings.SERVER_URL +
      AppSettings.GET_TRANS_TRUCK_DETAILS +
      transcode +
      "/" +
      truckno +
      "/" +
      tono;
    return this.http.get<any>(url, httpOptions).pipe(
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("getTruckDetail"))
    );
  }

  // USER (OBL,CBU)

  userQuery(): Observable<any> {
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${this.token}`,
        token: this.token,
      }),
    };
    let url = AppSettings.SERVER_URL + AppSettings.USER_DETAILS;
    return this.http.post<any>(url, httpOptions).pipe(
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("getOblQuery"))
    );
  }

  userSearch(searchData): Observable<any> {
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${this.token}`,
        token: this.token,
      }),
    };
    let url = AppSettings.SERVER_URL + AppSettings.USER_DETAILS;
    return this.http.post<any>(url, searchData, httpOptions).pipe(
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("Search User"))
    );
  }

  getUserTruckDetails(truckno, tono): Observable<any> {
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${this.token}`,
        token: this.token,
      }),
    };
    let url =
      AppSettings.SERVER_URL +
      AppSettings.GET_USER_TRUCK_DETAILS +
      truckno +
      "/" +
      tono;
    return this.http.get<any>(url, httpOptions).pipe(
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("getTruckDetail"))
    );
  }

  // EPOD

  podForm(data): Observable<any> {
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${this.token}`,
        token: this.token,
      }),
    };
    let url = AppSettings.SERVER_URL + AppSettings.POD_FORM_MASTER;
    return this.http.post<any>(url, data, httpOptions).pipe(
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("getVinDetail"))
    );
  }

  podFormSaved(v): Observable<any> {
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${this.token}`,
        token: this.token,
      }),
    };
    let url = AppSettings.SERVER_URL + "poddataweb/vinnumber/" + v;
    return this.http.get<any>(url, httpOptions).pipe(
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("getVinDetail"))
    );
  }

  getVin(data): Observable<any> {
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${this.token}`,
        token: this.token,
      }),
    };
    let url = AppSettings.SERVER_URL + AppSettings.GET_IMAGES;
    return this.http.post<any>(url, data, httpOptions).pipe(
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("getVin"))
    );
  }

  podSaveDetails(formData): Observable<any> {
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${this.token}`,
        token: this.token,
      }),
    };
    let url = AppSettings.SERVER_URL + AppSettings.SAVE_POD;
    return this.http.post<any>(url, formData, httpOptions).pipe(
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("PODsave"))
    );
  }

  // VLM UPLOAD

  vlmUpload(array): Observable<any> {
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${this.token}`,
        token: this.token,
      }),
    };
    let url = AppSettings.SERVER_URL + AppSettings.VLM_UPLOAD;
    console.log("In");
    return this.http.post<any>(url, array, httpOptions).pipe(
      // map(event => this.getEventMessage(event, array)),
      tap((data: any) => {
        this.sessionCheck(data);
        console.log("VLMUpload response:", data, "Array Sent:", array);
      }),
      catchError(this.handleError<any>("VLMUpload"))
    );
  }

  tts_Upload(array): Observable<any> {
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${this.token}`,
        token: this.token,
      }),
    };
    let url = AppSettings.SERVER_URL + "ledger/invoice/upload";
    return this.http.post<any>(url, array, httpOptions).pipe(
      // map(event => this.getEventMessage(event, array)),
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("VLMUpload"))
    );
  }

  ccUpload(array): Observable<any> {
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${this.token}`,
        token: this.token,
      }),
    };
    let url = AppSettings.SERVER_URL + "ccuploads";
    return this.http.post<any>(url, array, httpOptions).pipe(
      // map(event => this.getEventMessage(event, array)),
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("VLMUpload"))
    );
  }

  CreateMasterData(array): Observable<any> {
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${this.token}`,
        token: this.token,
      }),
    };
    let url = AppSettings.SERVER_URL + "makerchecker/data";
    return this.http.post<any>(url, array, httpOptions).pipe(
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("VLMUpload"))
    );
  }

  // Model and Matrix

  get_models(path): Observable<any> {
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${this.token}`,
        token: this.token,
      }),
    };
    let url = AppSettings.SERVER_URL + path;
    return this.http.get<any>(url, httpOptions).pipe(
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("getmodel"))
    );
  }

  add_model(data, path): Observable<any> {
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${this.token}`,
        token: this.token,
      }),
    };
    let url = AppSettings.SERVER_URL + path;
    return this.http.post<any>(url, data, httpOptions).pipe(
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("getmodel"))
    );
  }

  delete_model(id, path): Observable<any> {
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${this.token}`,
        token: this.token,
      }),
    };
    let url = AppSettings.SERVER_URL + path + "/" + id;
    return this.http.delete<any>(url, httpOptions).pipe(
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("getmodel"))
    );
  }

  update_model(data, path): Observable<any> {
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${this.token}`,
        token: this.token,
      }),
    };
    let url = AppSettings.SERVER_URL + path;
    return this.http.put<any>(url, data, httpOptions).pipe(
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("getmodel"))
    );
  }

  sobUpload(array): Observable<any> {
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${this.token}`,
        token: this.token,
      }),
    };
    let url = AppSettings.SERVER_URL + "transportersobs";
    return this.http.post<any>(url, array, httpOptions).pipe(
      // map(event => this.getEventMessage(event, array)),
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("VLMUpload"))
    );
  }

  manualLoad(data): Observable<any> {
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${this.token}`,
        token: this.token,
      }),
    };
    let url = AppSettings.SERVER_URL + "manual/load/allocation";
    return this.http.post<any>(url, data, httpOptions).pipe(
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("Manual Load"))
    );
  }

  manualUnLoad(data): Observable<any> {
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${this.token}`,
        token: this.token,
      }),
    };
    let url = AppSettings.SERVER_URL + "manual/unload/allocation";
    return this.http.post<any>(url, data, httpOptions).pipe(
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("Manual UnLoad"))
    );
  }

  manualTransporterUpdate(data): Observable<any> {
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${this.token}`,
        token: this.token,
      }),
    };
    let url = AppSettings.SERVER_URL + "exception/freight/allocation";
    return this.http.post<any>(url, data, httpOptions).pipe(
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("exception transporter"))
    );
  }

  manualRakeTransporterUpdate(data): Observable<any> {
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${this.token}`,
        token: this.token,
      }),
    };
    let url = AppSettings.SERVER_URL + "rake/freight/allocation";
    return this.http.post<any>(url, data, httpOptions).pipe(
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("exception transporter"))
    );
  }

  pickListQuery(data): Observable<any> {
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${this.token}`,
        token: this.token,
      }),
    };
    let url = AppSettings.SERVER_URL + "picklists";
    return this.http.post<any>(url, data, httpOptions).pipe(
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("getOblQuery"))
    );
  }

  linupQuery(data): Observable<any> {
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${this.token}`,
        token: this.token,
      }),
    };
    let url = AppSettings.SERVER_URL + "lineupmasters";
    return this.http.post<any>(url, data, httpOptions).pipe(
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("getOblQuery"))
    );
  }

  vinSwap(data): Observable<any> {
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${this.token}`,
        token: this.token,
      }),
    };
    let url = AppSettings.SERVER_URL + "lineup/swapvin";
    return this.http.post<any>(url, data, httpOptions).pipe(
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("getOblQuery"))
    );
  }

  addYard(data, mode): Observable<any> {
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${this.token}`,
        token: this.token,
      }),
    };
    let url = "";
    if (mode == "view") {
      url = AppSettings.SERVER_URL + "lineup/yardcheck";
    } else {
      url = AppSettings.SERVER_URL + "update/lineupmaster";
    }
    return this.http.post<any>(url, data, httpOptions).pipe(
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("getOblQuery"))
    );
  }

  updateBay(data, u): Observable<any> {
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${this.token}`,
        token: this.token,
      }),
    };
    let url = AppSettings.SERVER_URL + u;
    return this.http.post<any>(url, data, httpOptions).pipe(
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("getOblQuery"))
    );
  }

  // Maker Checker Config

  createMakerchecker(array): Observable<any> {
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${this.token}`,
        token: this.token,
      }),
    };
    let url = AppSettings.SERVER_URL + "makercheckerConfig";
    return this.http.post<any>(url, array, httpOptions).pipe(
      // map(event => this.getEventMessage(event, array)),
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("Maker Checker"))
    );
  }

  updateMakerchecker(array): Observable<any> {
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${this.token}`,
        token: this.token,
      }),
    };
    let url = AppSettings.SERVER_URL + "makercheckerConfig";
    return this.http.put<any>(url, array, httpOptions).pipe(
      // map(event => this.getEventMessage(event, array)),
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("Maker Checker"))
    );
  }

  // public getEventMessage(event: HttpEvent<any>, file: File) {
  //   switch (event.type) {
  //     case HttpEventType.Sent:
  //       return `Uploading file  of size ${file.size}.`;

  //     case HttpEventType.UploadProgress:
  //       // Compute and show the % done:
  //       const percentDone = Math.round(100 * event.loaded / event.total);
  //       console.log(`File "${file.name}" is ${percentDone}% uploaded.`)

  //       return `File "${file.name}" is ${percentDone}% uploaded.`;

  //     case HttpEventType.Response:
  //       return `File "${file.name}" was completely uploaded!`;

  //     default:
  //       return `File "${file.name}" surprising upload event: ${event.type}.`;
  //   }
  // }

  // ETA UPLOAD

  etaUpload(array): Observable<any> {
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${this.token}`,
        token: this.token,
      }),
    };
    let url = AppSettings.SERVER_URL + "etatracking/report";
    return this.http.post<any>(url, array, httpOptions).pipe(
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("etaUpload"))
    );
  }

  // SERVICE ASSIGNMENT

  updateService(data): Observable<any> {
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${this.token}`,
        token: this.token,
      }),
    };
    let url = AppSettings.SERVER_URL + AppSettings.UPDATE_SERVICES;

    return this.http.put<any>(url, data, httpOptions).pipe(
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("SERVICE"))
    );
  }

  // INVOICE

  invoiceSend(formData): Observable<any> {
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${this.token}`,
        token: this.token,
      }),
    };
    let url = AppSettings.SERVER_URL + AppSettings.INVOICE_SUBMIT;
    return this.http.post<any>(url, formData, httpOptions).pipe(
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("PODsave"))
    );
  }

  invoiceQuery(to): Observable<any> {
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${this.token}`,
        token: this.token,
      }),
    };
    let url = AppSettings.SERVER_URL + AppSettings.INVOICE_QUERY + to;
    return this.http.get<any>(url, httpOptions).pipe(
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("InvoiceQuery"))
    );
  }

  // YARD MANAGEMENT

  yardSearch(searchDate): Observable<any> {
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${this.token}`,
        token: this.token,
      }),
    };
    let url = AppSettings.SERVER_URL + "cardetail/data";
    return this.http.post<any>(url, searchDate, httpOptions).pipe(
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("yardSearch"))
    );
  }

  bayOccupied(searchDate): Observable<any> {
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${this.token}`,
        token: this.token,
      }),
    };
    let url = AppSettings.SERVER_URL + "cardetails/bayoccupied";
    return this.http.post<any>(url, searchDate, httpOptions).pipe(
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("yardSearch"))
    );
  }

  line1StockList(searchDate): Observable<any> {
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${this.token}`,
        token: this.token,
      }),
    };
    let url = AppSettings.SERVER_URL + "list";
    return this.http.post<any>(url, searchDate, httpOptions).pipe(
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("yardSearch"))
    );
  }

  bayVacanat(searchDate): Observable<any> {
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${this.token}`,
        token: this.token,
      }),
    };
    let url = AppSettings.SERVER_URL + "cardetails/vacant";
    return this.http.post<any>(url, searchDate, httpOptions).pipe(
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("yardSearch"))
    );
  }

  // DASHBOARD

  dealerDash(searchDate, code): Observable<any> {
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${this.token}`,
        token: this.token,
      }),
    };
    let url = AppSettings.SERVER_URL + AppSettings.DEALER_DASH + code;
    return this.http.post<any>(url, searchDate, httpOptions).pipe(
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("DealerDash"))
    );
  }

  dealerChart(searchDate, code): Observable<any> {
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${this.token}`,
        token: this.token,
      }),
    };
    let url = AppSettings.SERVER_URL + AppSettings.DEALER_CHART + code;
    return this.http.post<any>(url, searchDate, httpOptions).pipe(
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("DealerDash"))
    );
  }

  bayCount(d): Observable<any> {
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${this.token}`,
        token: this.token,
      }),
    };
    let url = AppSettings.SERVER_URL + AppSettings.BAYS_COUNT;
    return this.http.post<any>(url, d, httpOptions).pipe(
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("DealerDash"))
    );
  }

  vinCount(d): Observable<any> {
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${this.token}`,
        token: this.token,
      }),
    };
    let url = AppSettings.SERVER_URL + AppSettings.VINS_COUNT;
    return this.http.post<any>(url, d, httpOptions).pipe(
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("vinCount"))
    );
  }

  // NEW DYM

  vinModelCount(d): Observable<any> {
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${this.token}`,
        token: this.token,
      }),
    };
    let url = AppSettings.SERVER_URL + "model/parkshipped/count";
    return this.http.post<any>(url, d, httpOptions).pipe(
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("vinModelCount"))
    );
  }

  stockFindVin(d): Observable<any> {
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${this.token}`,
        token: this.token,
      }),
    };
    let url = AppSettings.SERVER_URL + "stock/findbyvins";
    return this.http.post<any>(url, d, httpOptions).pipe(
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("vinModelCount"))
    );
  }

  // TRANSPORTER DASHBOARD

  transDash(data): Observable<any> {
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${this.token}`,
        token: this.token,
      }),
    };
    let url = AppSettings.SERVER_URL + "transporter/dashboard/count";
    return this.http.post<any>(url, data, httpOptions).pipe(
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("transDash"))
    );
  }

  transCount(data): Observable<any> {
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${this.token}`,
        token: this.token,
      }),
    };
    let url = AppSettings.SERVER_URL + "count/brand";
    return this.http.post<any>(url, data, httpOptions).pipe(
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("transCount"))
    );
  }

  ngCatCount(data): Observable<any> {
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${this.token}`,
        token: this.token,
      }),
    };
    let url = AppSettings.SERVER_URL + "count/epodcattype";
    return this.http.post<any>(url, data, httpOptions).pipe(
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("ngCatCount"))
    );
  }

  CatCount(data): Observable<any> {
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${this.token}`,
        token: this.token,
      }),
    };
    let url = AppSettings.SERVER_URL + "model/gngstatus/count";
    return this.http.post<any>(url, data, httpOptions).pipe(
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("CatCount"))
    );
  }

  transitCount(data): Observable<any> {
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${this.token}`,
        token: this.token,
      }),
    };
    let url = AppSettings.SERVER_URL + "model/intransit/count";
    return this.http.post<any>(url, data, httpOptions).pipe(
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("CatCount"))
    );
  }

  stateWiseCount(data): Observable<any> {
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${this.token}`,
        token: this.token,
      }),
    };
    let url = AppSettings.SERVER_URL + "transporter/dashboard/map";
    return this.http.post<any>(url, data, httpOptions).pipe(
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("stateWiseCount"))
    );
  }

  // DEALER DASHBOARD

  delDash(data): Observable<any> {
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${this.token}`,
        token: this.token,
      }),
    };
    let url = AppSettings.SERVER_URL + "dealer/dashboard/count";
    return this.http.post<any>(url, data, httpOptions).pipe(
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("transDash"))
    );
  }

  ngDelCatCount(data): Observable<any> {
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${this.token}`,
        token: this.token,
      }),
    };
    let url = AppSettings.SERVER_URL + "dealer/cattype/count";
    return this.http.post<any>(url, data, httpOptions).pipe(
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("ngCatCount"))
    );
  }

  epodData(data): Observable<any> {
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${this.token}`,
        token: this.token,
      }),
    };
    let url = AppSettings.SERVER_URL + "filter/model/count";
    return this.http.post<any>(url, data, httpOptions).pipe(
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("ngCatCount"))
    );
  }

  // DTO DASHBOARD

  toCount(searchDate): Observable<any> {
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${this.token}`,
        token: this.token,
      }),
    };
    let url = AppSettings.SERVER_URL + AppSettings.TO_COUNT;
    return this.http.post<any>(url, searchDate, httpOptions).pipe(
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("DealerDash"))
    );
  }

  handyToCount(searchDate): Observable<any> {
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${this.token}`,
        token: this.token,
      }),
    };
    let url = AppSettings.SERVER_URL + AppSettings.HANDY_TO_COUNT;
    return this.http.post<any>(url, searchDate, httpOptions).pipe(
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("DealerDash"))
    );
  }

  //NEW DTO

  etoModelCount(d): Observable<any> {
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${this.token}`,
        token: this.token,
      }),
    };
    let url = AppSettings.SERVER_URL + "model/domesticexport/count";
    return this.http.post<any>(url, d, httpOptions).pipe(
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("vinModelCount"))
    );
  }

  // EPOD DASHBOARD

  // NEW EPOD

  epodDash(data): Observable<any> {
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${this.token}`,
        token: this.token,
      }),
    };
    let url = AppSettings.SERVER_URL + "obl/dashboard/count";
    return this.http.post<any>(url, data, httpOptions).pipe(
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("epodDash"))
    );
  }

  epodngCatCount(data): Observable<any> {
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${this.token}`,
        token: this.token,
      }),
    };
    let url = AppSettings.SERVER_URL + "obl/count/epodcattype";
    return this.http.post<any>(url, data, httpOptions).pipe(
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("ngCatCount"))
    );
  }

  epodStateWiseCount(data): Observable<any> {
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${this.token}`,
        token: this.token,
      }),
    };
    let url = AppSettings.SERVER_URL + "obl/dashboard/map";
    return this.http.post<any>(url, data, httpOptions).pipe(
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("stateWiseCount"))
    );
  }

  epodTransCount(data): Observable<any> {
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${this.token}`,
        token: this.token,
      }),
    };
    let url = AppSettings.SERVER_URL + "obl/count/brand";
    return this.http.post<any>(url, data, httpOptions).pipe(
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("transCount"))
    );
  }

  epodTransTop(data): Observable<any> {
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${this.token}`,
        token: this.token,
      }),
    };
    let url = AppSettings.SERVER_URL + "obl/transporter/ranking";
    return this.http.post<any>(url, data, httpOptions).pipe(
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("epodTransTop"))
    );
  }

  epodDelTop(data): Observable<any> {
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${this.token}`,
        token: this.token,
      }),
    };
    let url = AppSettings.SERVER_URL + "obl/dealer/ranking";
    return this.http.post<any>(url, data, httpOptions).pipe(
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("epodDelTop"))
    );
  }

  // OLD EPOD
  eta(searchDate): Observable<any> {
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${this.token}`,
        token: this.token,
      }),
    };
    let url = AppSettings.SERVER_URL + AppSettings.ETA_COUNT;
    return this.http.post<any>(url, searchDate, httpOptions).pipe(
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("DealerDash"))
    );
  }

  trackingChart(searchDate): Observable<any> {
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${this.token}`,
        token: this.token,
      }),
    };
    let url = AppSettings.SERVER_URL + AppSettings.TRACKING_CHART;
    return this.http.post<any>(url, searchDate, httpOptions).pipe(
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("trackingChart"))
    );
  }

  vinCondition(searchDate): Observable<any> {
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${this.token}`,
        token: this.token,
      }),
    };
    let url = AppSettings.SERVER_URL + AppSettings.EPOD_COUNT;
    return this.http.post<any>(url, searchDate, httpOptions).pipe(
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("DealerDash"))
    );
  }

  // VIN TRACKING

  // vinTracking(): Observable<any> {
  //   let url = AppSettings.SERVER_URL + AppSettings.VIN_TRACKING
  //   return this.http.get<any>(url, httpOptions).pipe(
  //     tap((VinTracking: any) => this.util.log(`Vin Tracking response returned`)),
  //     catchError(this.handleError<any>('VinTracking'))
  //   );
  // }

  vinTracking(data): Observable<any> {
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${this.token}`,
        token: this.token,
      }),
    };
    let url = AppSettings.SERVER_URL + "trackinglocations/filter";
    return this.http.post<any>(url, data, httpOptions).pipe(
      tap((data: any) => {
        this.sessionCheck(data);
        console.log("Data:", data);
      }),
      catchError(this.handleError<any>("VinTracking"))
    );
  }

  searchData(data: any): Observable<any[]> {
    let url = AppSettings.SERVER_URL + "trackinglocations/filter";
    return this.http.post<any>(url, data, httpOptions).pipe(
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("VinTracking"))
    );
  }

  vinTrackingToRack(data): Observable<any> {
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${this.token}`,
        token: this.token,
      }),
    };
    let url = AppSettings.SERVER_URL + "rack/vehicle/tracking";
    return this.http.post<any>(url, data, httpOptions).pipe(
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("VinTracking"))
    );
  }

  vinTrackingPerRack(vin): Observable<any> {
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${this.token}`,
        token: this.token,
      }),
    };
    let url = AppSettings.SERVER_URL + AppSettings.VIN_TIMELINE_RACK;
    return this.http.post<any>(url, { vinNumber: vin }, httpOptions).pipe(
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("VinTracking"))
    );
  }


  vinTrackingTo(data): Observable<any> {
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${this.token}`,
        token: this.token,
      }),
    };
    let url = AppSettings.SERVER_URL + "truckvehicle/tracking";
    return this.http.post<any>(url, data, httpOptions).pipe(
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("VinTracking"))
    );
  }

  vinTrackingPer(vin): Observable<any> {
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${this.token}`,
        token: this.token,
      }),
    };
    let url = AppSettings.SERVER_URL + AppSettings.VIN_TRACKING_PER + vin;
    return this.http.get<any>(url, httpOptions).pipe(
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("VinTracking"))
    );
  }

  vinTimeline(vin): Observable<any> {
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${this.token}`,
        token: this.token,
      }),
    };
    let url = AppSettings.SERVER_URL + AppSettings.VIN_TIMELINE + vin;
    return this.http.get<any>(url, httpOptions).pipe(
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("vinTimeline"))
    );
  }

  // TTS

  getGates() {
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${this.token}`,
        token: this.token,
      }),
    };
    let url = AppSettings.SERVER_URL + "gatemasters";
    return this.http.get<any>(url, httpOptions).pipe(
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("Gate"))
    );
  }

  gateIn(data) {
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${this.token}`,
        token: this.token,
      }),
    };
    let url = AppSettings.SERVER_URL + "truckservice";
    return this.http.post<any>(url, data, httpOptions).pipe(
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("gateIn"))
    );
  }

  gateOut(data) {
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${this.token}`,
        token: this.token,
      }),
    };
    let url = AppSettings.SERVER_URL + "truckservice";
    return this.http.put<any>(url, data, httpOptions).pipe(
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("gateIn"))
    );
  }

  gateOutQuery(data) {
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${this.token}`,
        token: this.token,
      }),
    };
    let url = AppSettings.SERVER_URL + "gateout/query";
    return this.http.post<any>(url, data, httpOptions).pipe(
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("GateOut"))
    );
  }

  getTrucks() {
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${this.token}`,
        token: this.token,
      }),
    };
    let url = AppSettings.SERVER_URL + "truck/distinct";
    return this.http.get<any>(url, httpOptions).pipe(
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("Gate"))
    );
  }

  ttsQuery(data) {
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${this.token}`,
        token: this.token,
      }),
    };
    let url = AppSettings.SERVER_URL + "truckservices";
    return this.http.post<any>(url, data, httpOptions).pipe(
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("ttsQuery"))
    );
  }

  ttsDashQuery(data) {
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${this.token}`,
        token: this.token,
      }),
    };
    let url = AppSettings.SERVER_URL + "gate/summary1";
    return this.http.post<any>(url, data, httpOptions).pipe(
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("ttsDashQuery"))
    );
  }

  ttsDashChart(data) {
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${this.token}`,
        token: this.token,
      }),
    };
    let url = AppSettings.SERVER_URL + "gateinout/count";
    return this.http.post<any>(url, data, httpOptions).pipe(
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("ttsDashChart"))
    );
  }

  ttsPendingChart(data) {
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${this.token}`,
        token: this.token,
      }),
    };
    let url = AppSettings.SERVER_URL + "pending/trailers";
    return this.http.post<any>(url, data, httpOptions).pipe(
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("ttsPendingChart"))
    );
  }

  // user activity

  userActivits(userData): Observable<any> {
    let url = AppSettings.SERVER_URL + "userconsole/data";
    return this.http.post<any>(url, userData, httpOptions).pipe(
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("UserActivity"))
    );
  }

  // CONFIG

  configQuery() {
    let url = AppSettings.SERVER_URL + "maintenances";
    return this.http.get<any>(url, httpOptions).pipe(
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("configQuery"))
    );
  }

  updateConfig(data) {
    let url = AppSettings.SERVER_URL + "maintenance";
    return this.http.post<any>(url, data, httpOptions).pipe(
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("updateConfig"))
    );
  }

  // TO

  getToCount(type) {
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${this.token}`,
        token: this.token,
      }),
    };
    let url =
      AppSettings.SERVER_URL + AppSettings.TO_COUNT_NO + type + "/" + "count";
    return this.http.get<any>(url, httpOptions).pipe(
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("getToCount"))
    );
  }
  getTransporters() {
    let httpOptions_common = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
      }),
    };
    let url = AppSettings.SERVER_URL + "transporters";
    return this.http.get<any>(url, httpOptions_common).pipe(
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("transporters"))
    );
  }
  getLocation() {
    let token = localStorage.getItem("token");
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${token}`,
        token: token,
      }),
    };
    let url = AppSettings.SERVER_URL + "locations";
    return this.http.get<any>(url, httpOptions).pipe(
      tap((data: any) => {
        try {
          this.sessionCheck(data);
          console.log("Response data:", data);
        } catch (err) {
          console.warn(err);
        }
      }),
      catchError(this.handleError<any>("locations"))
    );
  }
  getToTrucks() {
    let token = localStorage.getItem("token");
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${token}`,
        token: token,
      }),
    };
    let url = AppSettings.SERVER_URL + "gatein/tocreate/truck";
    console.log("Making request to:", url);
    return this.http.get<any>(url, httpOptions).pipe(
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("getToTrucks"))
    );
  }
  getVlmList(ids, type) {
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${this.token}`,
        token: this.token,
      }),
    };
    let url = AppSettings.SERVER_URL + "vlmbyvin/" + ids + "/" + type;
    return this.http.get<any>(url, httpOptions).pipe(
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("vlmbyvin"))
    );
  }

  CustommethodForVinSwap(ids) {
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${this.token}`,
        token: this.token,
      }),
    };
    let url = AppSettings.SERVER_URL + "vlmbyvin/swap";
    return this.http.post<any>(url, ids, httpOptions).pipe(
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("vlmbyvin"))
    );
  }

  getVlmListRail(ids, type: any = null) {
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${this.token}`,
        token: this.token,
      }),
    };
    let url = AppSettings.SERVER_URL + "vlmbyvin/" + ids + "/" + type;
    return this.http.get<any>(url, httpOptions).pipe(
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("vlmbyvin"))
    );
  }

  getToDetails(id) {
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${this.token}`,
        token: this.token,
      }),
    };
    let url = AppSettings.SERVER_URL + "transporterordervin/vindata/" + id;
    return this.http.get<any>(url, httpOptions).pipe(
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("getToDetails"))
    );
  }
  vinValidation(vin) {
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${this.token}`,
        token: this.token,
      }),
    };
    let url = AppSettings.SERVER_URL + AppSettings.VIN_VALIDATE;
    return this.http.post<any>(url, vin, httpOptions).pipe(
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("vlmbyvin"))
    );
  }

  remarksSubmit(data, u) {
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${this.token}`,
        token: this.token,
      }),
    };
    let url = AppSettings.SERVER_URL + u;
    return this.http.post<any>(url, data, httpOptions).pipe(
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("remarksSubmit"))
    );
  }

  deleteTo(to: string) {
    const token = this.token;
    let httpOptions = {
      headers: new HttpHeaders({
        Channel: "WEB",
        userId: localStorage.getItem("user_id") || "",
        Authorization: `Bearer ${token}`,
        token: token,
      }),
    };

    let url = `${AppSettings.SERVER_URL}${AppSettings.DELETE_TO}${to}`;

    return this.http.put<any>(url, null, httpOptions).pipe(
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("deleteTo"))
    );
  }

  getAllocatedList() {
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${this.token}`,
        token: this.token,
      }),
    };
    let url = AppSettings.SERVER_URL + "getloadedvins";
    return this.http.get<any>(url, httpOptions).pipe(
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("getAllocatedList"))
    );
  }

  swapSubmit(data) {
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${this.token}`,
        token: this.token,
      }),
    };
    let url = AppSettings.SERVER_URL + "vin/swap";
    return this.http.post<any>(url, data, httpOptions).pipe(
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("swapSubmit"))
    );
  }

  delSubmit(data) {
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${this.token}`,
        token: this.token,
      }),
    };
    let url = AppSettings.SERVER_URL + "/remove/tovin";
    return this.http.post<any>(url, data, httpOptions).pipe(
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("swapSubmit"))
    );
  }

  addSubmit(data) {
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${this.token}`,
        token: this.token,
      }),
    };
    let url = AppSettings.SERVER_URL + "/add/tovin";
    return this.http.post<any>(url, data, httpOptions).pipe(
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("swapSubmit"))
    );
  }

  // RAIL TO

  vlmDealercodeUpdate(dealercode) {
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${this.token}`,
        token: this.token,
      }),
    };
    let url = AppSettings.SERVER_URL + "/vlm/dealername/update";
    return this.http.put<any>(url, dealercode, httpOptions).pipe(
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("vlmDealercode"))
    );
  }

  //  HELP MODULE

  getHelp(id) {
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${this.token}`,
        token: this.token,
      }),
    };
    let url = AppSettings.SERVER_URL + "help/screen/" + id;
    return this.http.get<any>(url, httpOptions).pipe(
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("getHelp"))
    );
  }

  getAllHelp() {
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${this.token}`,
        token: this.token,
      }),
    };
    let url = AppSettings.SERVER_URL + "helps";
    return this.http.get<any>(url, httpOptions).pipe(
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("getAllHelp"))
    );
  }

  ///----------------------------------------T O  FORM-------------
  getTOList(searchData): Observable<any> {
    let token = localStorage.getItem("token");
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${token}`,
        token: token,
        "Content-Type": "application/json",
      }),
    };
    let url = AppSettings.SERVER_URL + "transportorders";
    return this.http.post<any>(url, searchData, httpOptions).pipe(
      tap((data: any) => {
        if (data) {
          try {
            this.sessionCheck(data);
          } catch (err) {
            console.warn("Error in sessionCheck:", err);
          }
        } else {
          console.warn("Received null or undefined data");
        }
      }),
      catchError((error) => {
        console.error("HTTP error in getTOList:", error);
        return this.handleError<any>("getTOList")(error);
      })
    );
  }

  getRailTOList(searchData): Observable<any> {
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${this.token}`,
        token: this.token,
      }),
    };
    let url = AppSettings.SERVER_URL + "/transportorders/transporterCode";
    return this.http.post<any>(url, searchData, httpOptions).pipe(
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("getTOList"))
    );
  }
  getTO(id): Observable<any> {
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${this.token}`,
        token: this.token,
      }),
    };
    let url = AppSettings.SERVER_URL + "transportorder/" + id;
    return this.http.get<any>(url, httpOptions).pipe(
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("getTO"))
    );
  }
  toFormSubmit(formData): Observable<any> {
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${this.token}`,
        token: this.token,
      }),
    };
    let url = AppSettings.SERVER_URL + "transportorder";
    return this.http.post<any>(url, formData, httpOptions).pipe(
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("toFormSubmit"))
    );
  }

  getMessagesAndCode(): Observable<any> {
    let httpOptions_common = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
      }),
    };
    let url = AppSettings.SERVER_URL + "messages";
    return this.http.get<any>(url, httpOptions_common).pipe(
      tap((data: any) => data),
      catchError(this.handleError<any>("toFormSubmit"))
    );
  }

  getAllAllocationData(data): Observable<any> {
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${this.token}`,
        token: this.token,
      }),
    };
    let url = AppSettings.SERVER_URL + "allocationmodelruns";
    return this.http.post<any>(url, data, httpOptions).pipe(
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("All Allocation Data"))
    );
  }

  getAllLoadByRunID(data): Observable<any> {
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${this.token}`,
        token: this.token,
      }),
    };
    let url = AppSettings.SERVER_URL + "vehicle/acceptance";
    return this.http.post<any>(url, data, httpOptions).pipe(
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("get All LoadBy RunID"))
    );
  }

  getAllocationData(data): Observable<any> {
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${this.token}`,
        token: this.token,
      }),
    };
    let url = AppSettings.SERVER_URL + "allocation/response";
    return this.http.post<any>(url, data, httpOptions).pipe(
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("Allocation Data"))
    );
  }
  publishedTTAData(data): Observable<any> {
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${this.token}`,
        token: this.token,
      }),
    };
    let url = AppSettings.SERVER_URL + "tta/published";
    return this.http.post<any>(url, data, httpOptions).pipe(
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("Published Data"))
    );
  }
  allocationSubmit(data): Observable<any> {
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${this.token}`,
        token: this.token,
      }),
    };
    let url = AppSettings.SERVER_URL + "allocation/update";
    return this.http.put<any>(url, data, httpOptions).pipe(
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("Allocation submit"))
    );
  }

  allocationPartSubmit(data): Observable<any> {
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${this.token}`,
        token: this.token,
      }),
    };
    let url = AppSettings.SERVER_URL + "allocation/partial/update";
    return this.http.put<any>(url, data, httpOptions).pipe(
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("Allocation Part Submit"))
    );
  }

  updateAcceptance(data): Observable<any> {
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${this.token}`,
        token: this.token,
      }),
    };
    let url = AppSettings.SERVER_URL + "dealerfreightcost/update";
    return this.http.put<any>(url, data, httpOptions).pipe(
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("Acceptance update"))
    );
  }

  transAcceptQuery(data): Observable<any> {
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${this.token}`,
        token: this.token,
      }),
    };
    let url = AppSettings.SERVER_URL + "transport/acceptance";
    return this.http.post<any>(url, data, httpOptions).pipe(
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("get Trans data"))
    );
  }

  getMakerCheckerData(data): Observable<any> {
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
        Authorization: `Bearer ${this.token}`,
        token: this.token,
      }),
    };
    let url = AppSettings.SERVER_URL + "makerchecker/masterscreen";
    return this.http.post<any>(url, data, httpOptions).pipe(
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("get Trans data"))
    );
  }

  logout(): Observable<any> {
    console.log("Logging out...");
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: localStorage.getItem("user_id"),
      }),
    };
    let url = AppSettings.SERVER_URL + "security/logout";
    return this.http.get<any>(url, httpOptions).pipe(
      tap((data: any) => {
        // id = "";
      }),
      catchError(this.handleError<any>("logout"))
    );
  }

  // LTSM

  getLTSMVin(data): Observable<any> {
    let url = AppSettings.SERVER_URL + "ltsm/data";
    return this.http.post<any>(url, data, httpOptions).pipe(
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("getLTSMVin"))
    );
  }

  getLTSMFormData(data): Observable<any> {
    let url = AppSettings.SERVER_URL + "ltsm/vin/data";
    return this.http.post<any>(url, data, httpOptions).pipe(
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("get Trans data"))
    );
  }

  checkLtsmPDI(path, data): Observable<any> {
    let url = AppSettings.SERVER_URL + path;
    return this.http.post<any>(url, data, httpOptions).pipe(
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("get Trans data"))
    );
  }

  getLTSM_VIN_Details(data, vin): Observable<any> {
    let url = AppSettings.SERVER_URL + vin;
    return this.http.get<any>(url, httpOptions).pipe(
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("getLTSM_VIN_Details"))
    );
  }

  getInvoice(obj: any): Observable<any> {
    let url = "http://192.168.1.62:9090/rest/api/v1/invoice/report";
    return this.http.post<any>(url, obj).pipe(
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("getLTSM_VIN_Details"))
    );
  }

  ltsmQuery(path): Observable<any> {
    let url = AppSettings.SERVER_URL + path;
    return this.http.get<any>(url, httpOptions).pipe(
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("getLTSMVin"))
    );
  }

  getformdatas(data, path): Observable<any> {
    let url = AppSettings.SERVER_URL + path;
    return this.http.post<any>(url, data, httpOptions).pipe(
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("get Trans data"))
    );
  }

  // OLD API

  getAssignedMenuServicesByRole(roleId): Observable<any> {
    let url = AppSettings.SERVER_URL + AppSettings.MENU_SERVICES_QUERY + roleId;
    return this.http.get<any>(url, httpOptions).pipe(
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("menuServiceQuery"))
    );
  }

  getInvoiceDetails(transid, truckno, toid): Observable<any> {
    let url =
      AppSettings.SERVER_URL +
      AppSettings.GET_INVOICE_DETAILS +
      transid +
      "/" +
      truckno +
      "/" +
      toid;
    return this.http.get<any>(url, httpOptions).pipe(
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("getInvoiceDetails"))
    );
  }
  getInvoiceDetailsUser(truckno, toid): Observable<any> {
    let url =
      AppSettings.SERVER_URL +
      AppSettings.GET_INVOICE_DETAILS_USER +
      truckno +
      "/" +
      toid;
    return this.http.get<any>(url, httpOptions).pipe(
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("getInvoiceDetails"))
    );
  }
  getInvoiceVinDetails(transid, truckno, toid): Observable<any> {
    let url =
      AppSettings.SERVER_URL +
      AppSettings.GET_INVOICE_VIN_DETAILS +
      transid +
      "/" +
      truckno +
      "/" +
      toid;
    return this.http.get<any>(url, httpOptions).pipe(
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("getInvoiceVinDetails"))
    );
  }
  getVinFormDetails(vin): Observable<any> {
    let url = AppSettings.SERVER_URL + AppSettings.GET_VIN_FORM + vin;
    return this.http.get<any>(url, httpOptions).pipe(
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("getVinDetail"))
    );
  }
  podFormSelected(vin): Observable<any> {
    let url = AppSettings.SERVER_URL + AppSettings.GET_FORM_SELECTED_DATA + vin;
    return this.http.get<any>(url, httpOptions).pipe(
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("getVinDetail"))
    );
  }
  getInvoiceList(toid, transid): Observable<any> {
    let url =
      AppSettings.SERVER_URL +
      AppSettings.GET_INVOICE_LIST +
      toid +
      "/" +
      transid;
    return this.http.get<any>(url, httpOptions).pipe(
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("InvoiceList"))
    );
  }

  getInvoiceListUser(toid): Observable<any> {
    let url = AppSettings.SERVER_URL + AppSettings.GET_INVOICE_LIST_USER + toid;
    return this.http.get<any>(url, httpOptions).pipe(
      tap((data: any) => this.sessionCheck(data)),
      catchError(this.handleError<any>("InvoiceList"))
    );
  }

  errorCount = 0;
  /**
   * Handle Http operation that failed.
   * Let the app continue.
   * @param operation - name of the operation that failed
   * @param result - optional value to return as the observable result
   */
  public handleError<T>(
    operation = "operation",
    result?: T
  ): (error: any) => Observable<T> {
    return (error: any): Observable<T> => {
      if (!error) {
        console.error(`${operation} failed: Unknown error`);
        return of(result as T);
      }

      // Log the entire error for debugging purposes
      console.error("Error received in handleError:", error);

      // Safely check if error.message exists and is a non-empty string
      if (
        error.message &&
        typeof error.message === "string" &&
        error.message.length > 0
      ) {
        console.error(`${operation} failed: ${error.message}`);
      } else {
        console.error(
          `${operation} failed with an unexpected error structure`,
          error
        );
      }

      // Handle specific HTTP error statuses
      switch (error.status) {
        case 0:
          if (this.errorCount === 0) {
            alert("Server is not reachable. Please contact system admin.");
            this.errorCount++;
          }
          break;
        case 401:
          if (this.errorCount === 0) {
            alert("Timeout error. Please try again");
            this.errorCount++;
          }
          break;
        case 500:
        case 501:
          if (this.errorCount === 0) {
            alert("Internal Server Error. Please try again");
            this.errorCount++;
          }
          break;
        case 400:
          if (this.errorCount === 0) {
            alert("Bad request");
            this.errorCount++;
          }
          break;
        case 404:
          if (this.errorCount === 0) {
            alert("Not Found. Please check the resource or endpoint");
            this.errorCount++;
          }
          break;
        case 403:
          if (this.errorCount === 0) {
            alert(
              "Forbidden. You do not have permission to access this resource"
            );
            this.errorCount++;
          }
          break;
        default:
          console.error(`Unhandled error status: ${error.status}`);
          this.errorCount = 0;
      }

      return of(result as T);
    };
  }

  forceLogin(u, userData): Observable<any> {
    let httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": AppSettings.HTTP_CONTENT_TYPE,
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
      }),
    };
    let url = AppSettings.SERVER_URL + u;
    return this.http.post<any>(url, userData, httpOptions);
  }

  forceLogout(urlstr: any, userId?: any): Observable<any> {
    let token = localStorage.getItem("token");
    let httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": AppSettings.HTTP_CONTENT_TYPE,
        "Access-Control-Allow-Origin":
          AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
        Channel: "WEB",
        userId: userId,
        Authorization: `Bearer ${token}`,
        token: token,
      }),
    };
    let url = AppSettings.SERVER_URL + urlstr;
    return this.http.post<any>(url, { userId: userId }, httpOptions);
  }
}
